import {
  APP_TITLE,
  ORG_LOGO,
  ORG_LOGOS_BY_LANG,
  ORG_SHORT_NAME,
} from "../../../util/appInfo";

const Logo = ({ useSquare, language, title, ...props }) => {
  const orgName = ORG_SHORT_NAME.toLowerCase();
  const logoName = `${ORG_LOGO}${useSquare ? "-square" : ""}`;

  const resolveLogo = () => {
    if (ORG_LOGOS_BY_LANG) {
      try {
        return require(
          `../../../assets/images/${orgName}/${logoName}-${language}.png`
        );
      } catch {
        return require(`../../../assets/images/${orgName}/${logoName}-en.png`);
      }
    }
    return require(`../../../assets/images/${orgName}/${logoName}.png`);
  };

  return (
    <img
      {...props}
      alt={title ?? APP_TITLE}
      title={title ?? APP_TITLE}
      src={resolveLogo()}
    />
  );
};

export { Logo };
